import React from 'react'
import clsx from 'clsx'
import { TextareaAutosize } from '@mui/material'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import BaseModal from '@SonarCX/components/molecules/ChatModals/BaseModal2'
import Button from '@SonarCX/components/atoms/Button2'

import { createFlow } from '@SonarCX/slices/customFields/flows'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useCommonStyles from '../../GroupSettings/NewGroupModal/styles'

type NewFlowModalProps = {
  title: string
  object_type: APIFlow['object_type']
  onClose: () => void
}

const NewFlowModal: React.FC<NewFlowModalProps> = ({
  title,
  object_type,
  onClose
}) => {
  const dispatch = useAppDispatch()

  const { isMedium } = useBreakpoint()

  const [name, setName] = React.useState('')
  const [description, setDescription] = React.useState('')

  const commonClasses = useCommonStyles()

  const handleSave = React.useCallback(() => {
    const desc = description.trim()
    const newFlow: FlowUpdate = {
      object_type,
      title: name,
      description: desc === '' ? null : desc,
      archived_at: null,
      fields: []
    }
    dispatch(createFlow(newFlow))
    onClose()
  }, [dispatch, description, name, onClose, object_type])

  return (
    // @ts-ignore
    <BaseModal
      open
      title={`Add New ${title} Flow Stage`}
      onClose={onClose}
      PaperProps2={{
        style: {
          padding: '20px 16px 24px 16px',
          border: '1px solid #C6C6C6',
          borderRadius: '4px',
          width: isMedium ? 'calc(100% - 4rem)' : '100%',
          maxWidth: isMedium ? 'unset' : '360px',
          height: isMedium && `auto`,
          maxHeight: isMedium && 'unset',
          minHeight: isMedium && 'auto'
        }
      }}
      classes={{
        title: commonClasses.modalTitle,
        close: commonClasses.modalClose
      }}
    >
      <div className={commonClasses.name}>Title</div>

      <input
        autoFocus
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder='Enter flow name'
        className={commonClasses.input}
      />

      <div className={commonClasses.name}>Description</div>

      <TextareaAutosize
        minRows={1}
        maxRows={5}
        value={description}
        onChange={e => setDescription(e.target.value)}
        placeholder='Enter flow description'
        className={clsx(commonClasses.input, commonClasses.textArea)}
      />

      <Button
        onClick={handleSave}
        disabled={name.trim().length === 0}
        className={commonClasses.button}
      >
        Add Flow
      </Button>
    </BaseModal>
  )
}

export default NewFlowModal
